import { nanoid } from 'nanoid'
import { type ActionItem } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { ModalTypeList } from 'shared/ui/Modal/store/types.ts'
import {
  type IWebhookActionContentProps,
  WebhookActionContent,
} from 'widgets/EnrollByWebhook/actions/webhookAction/ui/WebhookActionContent.tsx'

export const showWebhookActionModal = (props: IWebhookActionContentProps) =>
  modalStore.addModal({
    id: nanoid(),
    width: 480,
    type: ModalTypeList.DEFAULT,
    ModalContent: () => <WebhookActionContent {...props} />,
    title: 'Webhook URL',
    pureContent: true,
    disabledOnAllClose: true,
  })

export const webhookAction = (props: IWebhookActionContentProps): ActionItem | null => {
  return {
    icon: 'link',
    onAction: () => showWebhookActionModal(props),
    text: 'Webhook',
  }
}
